import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const HomeScreen = ({ backgroundImage }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <div className={styles.headContainer}>
          <img
            className={styles.logo}
            src={getImageFromS3('images/sms-mpm-20/logo.png')}
            alt="logo"
          />
          <p className={styles.headTitle}>
            <b>Philip Morris Red</b> та <b>Blue</b>
            <br /> в форматі 20 сигарет у пачці
          </p>
          <div className={styles.headShadow} />
        </div>
        <div className={styles.packContainer}>
          <div className={styles.packs}>
            <img
              src={getImageFromS3('images/sms-mpm-20/red-pack.png')}
              alt="red-pack"
            />
            <img
              src={getImageFromS3('images/sms-mpm-20/blue-pack.png')}
              alt="blue-pack"
            />
          </div>
          <img
            className={styles.packsSubtitle}
            src={getImageFromS3('images/sms-mpm-20/packs-subtitle.png')}
            alt="packs-subtitle"
          />
        </div>
        <div className={styles.characteristicContainer}>
          <div>
            <p>9 мг</p>
            <p>вміст смол</p>
            <p>6 мг</p>
          </div>
          <div>
            <p>0.7 мг</p>
            <p>вміст нікотину</p>
            <p>0.5 мг</p>
          </div>
        </div>
        <div className={styles.disclaimerContainer}>
          *зазначено задекларовану максимальну роздрібну ціну з урахуванням
          акцизного податку на роздрібний продаж тютюнових виробів станом на
          листопад 2025 року
        </div>
        <div className={styles.cigaretteContainer}>
          <div>
            <img
              src={getImageFromS3('images/sms-mpm-20/filter.png')}
              alt="filter"
            />
            <p>
              Ацетатний
              <br /> фільтр
            </p>
          </div>
          <div>
            <img
              src={getImageFromS3('images/sms-mpm-20/tobacco.png')}
              alt="tobacco"
            />
            <p>
              Бленд з трьох
              <br /> сортів тютюну
            </p>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <div className={styles.buyContent}>
            <p className={styles.buyTitle}>Де купити?</p>
            <p className={styles.buyDescription}>
              <b>Philip Morris Red 20</b> та <b>Philip Morris Blue 20</b> можна
              знайти у роздрібних точках продажу в твоєму місті або на офіційних
              онлайн сервісах, зокрема:
            </p>
            <div className={styles.buttonContainer}>
              <button onClick={() => sendEvent('rozetka')}>
                <a href="https://rozetka.com.ua/ua/sigareti/c4638591/producer=philip-morris/?utm_source=PMUsmsMPM20_jun">
                  Rozetka
                </a>
              </button>
              <button onClick={() => sendEvent('Cig-Poshta')}>
                <a href="https://cig-poshta.in.ua/shop/philip-morris/?utm_source=CDAsmsMPM20_jun">
                  Cig-Poshta
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-mpm-20">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
